import React, { useContext, useState } from 'react';
import { Settings, Undo2 } from 'lucide-react';
import { AutomationEditorContext } from '../AutomationEditorContext';
import { SettingsDialog } from './SettingsDialog';
import styles from './SettingsControls.module.css';

export const SettingsControl: React.FC = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { editor } = useContext(AutomationEditorContext)!;
  const { state, undoSettings } = editor;
  const isDirty = state.dirtySteps.settings;

  return (
    <>
      {isDirty && (
        <button
          type="button"
          onClick={undoSettings}
          className={styles.undoButton}
          aria-label="Undo settings changes"
          title="Undo settings changes">
          <Undo2 />
        </button>
      )}
      <button
        type="button"
        onClick={() => setDialogOpen(true)}
        className={styles.settingsButton}>
        <Settings className={styles.settingsIcon} />
      </button>
      <SettingsDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
};
